<template>
	<div>
		<vs-popup class="holamundo" :title="$t('AddExcel')" :active.sync="isSidebarActiveLocal" fullscreen
			@cancel="clearFields" @close="clearFields">
			<b-row>
				<b-col lg="5">
					<b-row align-v="center">
						<vs-card>
							<b-row>
								<b-col v-if="ROLE != 'Company'">
									<b-row class="mb-2">
										<b-col cols="3" align-self="center">
											<b-form-group :label="'* ' + $t('Customer') + ': '" class="vs-input--label pr-0 mr-0"
												label-for="h-first-name" style="font-weight: 600">
											</b-form-group>
										</b-col>
										<b-col cols="9">
											<v-select color="danger" v-model="customer" :options="customer_choices" size="small" label="name"
												v-on:input="getCustomerDepoList()" autocomplete ref="selectElement">
											</v-select>
										</b-col>
									</b-row>
								</b-col>
							</b-row>
							<b-row class="mb-2">
								<b-col cols="3" align-self="center">
									<b-form-group :label="'* ' + $t('Storehouse') + ': '" class="vs-input--label pr-0 mr-0"
										label-for="h-first-name" style="font-weight: 600">
									</b-form-group>
								</b-col>
								<b-col cols="9">
									<v-select color="danger" v-model="storehouse" :options="storehouse_choices" size="small" label="name"
										autocomplete ref="selectElement" name="storehouse" v-validate="'required'">
									</v-select>

									<span class="text-danger text-sm" v-show="errors.has('storehouse')">{{
										errors.first("storehouse")
									}}</span>
								</b-col>
							</b-row>
							<b-row class="mb-8 mt-8">
								<UploadBtnDynamic :isUploaded="isUploaded" :isValidate="storehouse && customer ? true : false" />
							</b-row>
							<b-row class="justify-content-md-end">
								<b-col cols="12" md="auto" class="ml-2" style="padding: 0px">
									<b-button class="bg-danger" style="border-color: white" v-on:click="clear()">
										<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20" height="20" />{{
											$t("Cancel") }}
									</b-button>
								</b-col>
								<b-col cols="12" md="auto" style="padding: 0px">
									<b-button class="bg-success" style="border-color: white" v-on:click="downloadSample()">
										{{ $t("SampleExcel") }}</b-button>
								</b-col>
								<b-col cols="12" md="auto" style="padding: 0px">
									<b-button style="border-color: white" v-on:click="wholeStockSave()"
										class="vs-con-loading__container bg-primary" id="loading-stockList">
										{{ $t("AddWholeExcel") }}
									</b-button></b-col>
							</b-row>
						</vs-card>
					</b-row>
				</b-col>
				<b-col>
					<vs-card>
						<ag-grid-vue style="width: 100%; height: 400px; margin-top: 15px" class="ag-theme-alpine"
							:enableCellChangeFlash="true" :animateRows="true" :defaultColDef="defaultColDef"
							:columnDefs="columnDefsForExcel" :rowData="wholeStockList" :localeText="localeText"
							:suppressCopyRowsToClipboard="true" :pagination="true">
						</ag-grid-vue>
					</vs-card>
				</b-col>
			</b-row>
		</vs-popup>
	</div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import userJson from "../../../public/user.json";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import UploadBtnDynamic from "../components/global-components/UploadBtnDynamic.vue";
import { uuid } from "vue-uuid";
export default {
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true,
		},
		data: {
			default: () => { },
		},
	},
	components: {
		uuid,
		UploadBtnDynamic,
		vSelect,
		Icon,
		AgGridVue,
	},
	data() {
		return {
			isValidateExcel: false,
			isUploaded: false,
			type: userJson.type,
			storehouse: "",
			customer: "",
			storehouse_choices: [],
			customer_choices: [],
			ROLE: this.$store.state.AppActiveUser.ROLE,
			wholeStockList: [],

			defaultColDef: {
				sortable: true,
				resizable: true,
			},
			columnDefsForExcel: null,
		};
	},
	methods: {
		clearFields() {
			this.wholeStockList = [];
			this.isUploaded = false;
			this.isValidateExcel = false;
			this.storehouse = "";
			this.customer = "";
			document.getElementById("xmlListForExcel").value = "";
		},
		downloadSample() {
			const link = document.createElement("a");
			link.href = userJson.assetsUrl + "SampleStockTemplate.xlsx";
			link.download = "SampleStockTemplate.xlsx";
			link.click();
		},
		clear() {
			this.wholeStockList = [];
			this.isUploaded = false;
		},
		getCustomerDepoList() {
			const vs = this.$vs;
			this.storehouse_choices = [];
			if (userJson.type == "fullfilment")
				this.$store.dispatch("storehouse/listStorehouseAllValues2").then((response) => {
					// let costumerList = JSON.parse(response.json);

					if (response.success == true) {
						this.storehouseForCustomerList = this.storehouseA;
						this.storehouseForCustomerList.forEach((val, index) => {
							this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
						});
					} else console.log(response.statusText);
					/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
				});
			else {
				let depotMethods = "listStorehouseForCompany"

				if (userJson.type == "dropshipping") depotMethods = "listStorehouseAllValues2Ds"
				this.$store
					.dispatch("storehouse/" + depotMethods, this.customer.value)
					.then((response) => {
						// let costumerList = JSON.parse(response.json);

						if (response.success == true) {
							this.storehouseForCustomerList = JSON.parse(response.json);
							this.storehouseForCustomerList.forEach((val, index) => {
								this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
							});
						} else console.log(response.statusText);
						/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
					});
			}
		},
		getCustomerList(id, popup) {
			this.customerListOption = [];
			this.customer_choices = [];
			this.customerListOption = this.companydata;
			this.customerListOption.forEach((val, index) => {
				this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
			});
		},
		wholeStockSave() {
			const vs = this.$vs;

			let type = "material";
			vs.loading({
				container: `#loading-stockList`,
				type,
				scale: 0.75,
			});
			let wholeStocks = [];
			this.wholeStockList.forEach((val, index) => {
				var createdId = uuid.v4();
				let barcodeList = [];
				if (val.barcode.toString().includes(";")) {
					barcodeList = val.barcode.toString().split(";");
				} else {
					barcodeList.push(val.barcode.toString());
				}
				wholeStocks.push({
					CompanyId: this.customer.value,
					CompanyInfoId: "",
					CompanyInfoName: "",
					CompanyName: this.customer.name,
					stockId: createdId,
					stockno: val.stockno.toString(),
					stockName: val.stockName.replace(/'/g, ""),
					brand: val.brand ? val.brand : "Marka",
					groupCode: val.groupCode ? val.groupCode.toString() : "Group 1",
					specCode1: val.specCode1,
					specCode2: val.specCode2,
					specCode3: val.specCode3,
					specCode4: val.specCode4,
					specCode5: val.specCode5,
					specCode6: val.specCode6,
					specCode7: val.specCode7,
					specCode8: val.specCode8,
					specCode9: val.specCode9,
					specCode10: val.specCode10,
					status: 1,
					note: val.note ? val.note : "",
					cancelDate: null,
					description: val.description ? val.description : "",
					debit: val.debit ? val.debit : 0,
					credit: val.credit ? val.credit : 0,
					remTotal: val.remTotal ? val.remTotal : 0,
					remType: val.remType ? val.remType : 0,
					currCode: val.currCode ? val.currCode : "TL",
					currDebit: val.currDebit ? val.currDebit : 0,
					currCredit: val.currCredit ? val.currCredit : 0,
					currRemTotal: val.currRemTotal ? val.currRemTotal : 0,
					currRemType: val.curr ? val.curr : 0,
					qEntery: val.qEntery ? val.qEntery : 0,
					qExit: val.qExit ? val.qExit : 0,
					qRem: val.qRem ? val.qRem : 0,
					qRem2: val.qRem2 ? val.qRem2 : 0,
					qRem3: val.qRem3 ? val.qRem3 : 0,
					qReserve: val.qReserve ? val.qReserve : 0,
					qReserve2: val.qReserve2 ? val.qReserve2 : 0,
					qReserve3: val.qReserve3 ? val.qReserve3 : 0,
					qDepot: val.qDepot ? val.qDepot : 0,
					stockName2: val.stockName2,
					unitId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					vatSales: val.vatSales ? val.vatSales : 20,
					vatPurChase: val.vatPurChase ? val.vatPurChase : 0,
					quantityMin: val.quantityMin ? val.quantityMin : 0,
					quantityMax: val.quantityMax ? val.quantityMax : 0,
					minOrderQuantity: val.minOrderQuantity ? val.minOrderQuantity : 0,
					taxPrivate: val.taxPrivate ? val.taxPrivate : 0,
					taxPrivateTotal: val.taxPrivateTotal ? val.taxPrivateTotal : 0,
					ordersLevel: val.ordersLevel ? val.ordersLevel : 0,
					actSupplierId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					packageQuantity: val.packageQuantity ? val.packageQuantity : 0,
					customerStockNo: val.customerStockNo ? val.customerStockNo.toString() : "",
					msg: val.msg ? val.msg : "",
					minReqQuantity: val.minReqQuantity ? val.minReqQuantity : 0,
					transCode: val.transCode,
					origin: val.origin ? val.origin : "",
					qtyTree: val.qtyTree ? val.qtyTree : 0,
					depotId: this.storehouse.value,
					depotName: this.storehouse.name,
					barcode: barcodeList[0], //?
					companyId: this.customer.value,
					companyName: this.customer.name,
					serialFollow: val.serialFollow ? (val.serialFollow == 1 ? true : false) : false,
				});
			});
			this.$store
				.dispatch("stock/addStockList", wholeStocks)
				.then((response) => {
					if (response.status == 200) {
						setTimeout(() => {
							vs.loading.close("#loading-stockList > .con-vs-loading");
						}, 1000);
						this.$store.dispatch("stock/listStockForRole").then((response) => {
							if (response)
								if (response.success == true) {
								} else console.log(response);
						});
						vs.notify({
							text: response.data.message,
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "success",
							position: "top-center",
						});
					} else {
						setTimeout(() => {
							vs.loading.close("#loading-stockList > .con-vs-loading");
						}, 1000);
						vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
					}
				})
				.catch((error) => {
					setTimeout(() => {
						vs.loading.close("#loading-stockList > .con-vs-loading");
					}, 1000);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		setItems(items) {
			const vs = this.$vs;
			if (this.customerExcel == "") {
				vs.notify({
					text: this.$t("Validate"),
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning",
					position: "top-center",
				});
			} else {
				let list = this.wholeStockList[0];
				let columnList = Object.keys(list);
				let searched = [
					"stockno",
					"barcode",
					"stockName",
					"groupCode",
					"status",
					"vatSales",
					"customerStockNo",
					"brand",
				];

				const isEveryOk = searched.every((value) => columnList.includes(value));

				if (isEveryOk) {
					const colQty = searched.map((value) => {
						const quantity = columnList.filter((item) => item === value).length;
						return { value, quantity };
					});
					const filteredData = colQty.filter((item) => item.quantity > 1);

					if (filteredData.length > 0) {
						vs.notify({
							text: "Bazı değerler iki adet bulunuyor: " + filteredData.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "warning",
							position: "top-center",
						});
					}
				} else {
					vs.notify({
						text: "Zorunlu alanları kontrol ediniz: " + searched.toString(),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "success",
						position: "top-center",
					});
				}
			}
		},
	},
	computed: {
		storehouseA: {
			get() {
				return this.$store.state.storehouse.Storehouse;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
					// this.$validator.reset()
					// this.initValues()
				}
			},
		},
		localeText() {
			return i18nData[this.$i18n.locale];
		},
		companydata: {
			get() {
				return this.$store.state.customer.Customer;
			},
			set(val) {
				if (!val) {
				}
			},
		},
	},
	watch: {
		storehouseA(val) {
			return val;
		},
		isSidebarActive(val) {
			if (val == true) {
				if (this.ROLE != "Company") this.getCustomerList();

				if (this.type == "fullfilment") this.getCustomerDepoList();
				this.localData = this.data;
			}
			return val;
		},
		companydata(val) {
			this.getCustomerList();
			return val;
		},
	},
	mounted() {
		//tables global olarak tanımlanıyor

		this.$root.$on("excelData", (paramDetail) => {
			if (paramDetail) this.isUploaded = true;
			this.wholeStockList = paramDetail;
			this.setItems();
		});
	},
	beforeDestroy() {
		this.$root.$off("excelData");
	},
	beforeMount() {
		this.columnDefsForExcel = [
			{
				headerName: this.$t("stockno"),
				field: "stockno",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("barcode"),
				field: "barcode",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("stockName"),
				field: "stockName",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("groupCode"),
				field: "groupCode",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("specCode1"),
				field: "specCode1",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("specCode2"),
				field: "specCode2",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("specCode3"),
				field: "specCode3",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("specCode4"),
				field: "specCode4",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("specCode5"),
				field: "specCode5",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("specCode6"),
				field: "specCode6",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("specCode7"),
				field: "specCode7",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("specCode8"),
				field: "specCode8",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("specCode9"),
				field: "specCode9",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("specCode10"),
				field: "specCode10",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("status"),
				field: "status",
				filter: "agSetColumnFilter",
				editable: true,
				valueFormatter: (params) => {
					if (!params.value && params.value !== 0) return "";
					return Number(params.value).toLocaleString();
				},
			},
			{
				headerName: this.$t("note"),
				field: "note",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("cancelDate"),
				field: "cancelDate",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("description"),
				field: "description",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("debit"),
				field: "debit",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("credit"),
				field: "credit",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("remTotal"),
				field: "remTotal",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("remType"),
				field: "remType",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("currCode"),
				field: "currCode",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("currDebit"),
				field: "currDebit",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("currCredit"),
				field: "currCredit",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("currRemTotal"),
				field: "currRemTotal",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("currRemType"),
				field: "currRemType",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("qEntery"),
				field: "qEntery",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("qExit"),
				field: "qExit",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("qRem"),
				field: "qRem",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("qRem2"),
				field: "qRem2",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("qRem3"),
				field: "qRem3",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("qReserve"),
				field: "qReserve",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("qReserve2"),
				field: "qReserve2",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("qReserve3"),
				field: "qReserve3",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("qDepot"),
				field: "qDepot",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("stockName2"),
				field: "stockName2",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("vatSales"),
				field: "vatSales",
				filter: "agSetColumnFilter",
				editable: true,
				valueFormatter: (params) => {
					if (!params.value && params.value !== 0) return "";
					return Number(params.value).toLocaleString();
				},
			},
			{
				headerName: this.$t("vatPurChase"),
				field: "vatPurChase",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("quantityMin"),
				field: "quantityMin",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("quantityMax"),
				field: "quantityMax",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("minOrderQuantity"),
				field: "minOrderQuantity",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("taxPrivate"),
				field: "taxPrivate",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("taxPrivateTotal"),
				field: "taxPrivateTotal",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("ordersLevel"),
				field: "ordersLevel",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("packageQuantity"),
				field: "packageQuantity",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("customerStockNo"),
				field: "customerStockNo",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("msg"),
				field: "msg",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("minReqQuantity"),
				field: "minReqQuantity",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("transCode"),
				field: "transCode",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("origin"),
				field: "origin",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("qtyTree"),
				field: "qtyTree",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("depotName"),
				field: "depotName",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("brand"),
				field: "brand",
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("serialFollow"),
				field: "serialFollow",
				filter: "agSetColumnFilter",

			},
		];
	},
};
</script>
